module.exports = __webpack_public_path__ + "static/img/u-hub-logo.97a5274.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u-hub-logo.png
// module id = lxRE
// module chunks = 1